export class TableContentComponent {
  container = null;

  toggler = null;

  constructor() {
    const container = document.querySelector('body.single-post #ez-toc-container');
    if (!container) {
      return;
    }

    this.container = container;

    this.addEventListeners();
  }

  addEventListeners() {
    const toggler = this.container.querySelector('.ez-toc-toggle');
    if (toggler) {
      toggler.addEventListener('click', (e) => this.togglerClickHandler(e));
    }
  }

  togglerClickHandler(e) {
    const target = e.target;
    const parent = target.closest('#ez-toc-container');

    this.toggleActive(parent);
  }

  initialize() {
    const content = this.container.querySelector('nav ul');
    if (!content) {
      return;
    }

    if (content.style.display === '') {
      this.container.classList.add('active');
    }
  }

  toggleActive(element) {
    if (!element) {
      return;
    }

    element.classList.contains('active')
      ? element.classList.remove('active')
      : element.classList.add('active');
  }
}